module.exports = __webpack_public_path__ + "static/media/item_6_9_comp.44c35012.png";